module.exports = __webpack_public_path__ + "img/fuzhou.41c66168.jpg";